export type PalierScore = 'faible' | 'correct' | 'bon' | 'excellent';

/**
 * Palier d'un score sur 100, pour poser un verdict en mots. Les bornes suivent les couleurs de
 * l'anneau (`couleurAnneau` : rouge sous 60, bleu jusqu'à 85, vert au-delà) : le verdict et la
 * couleur doivent dire la même chose. Le score est arrondi comme l'anneau l'arrondit.
 *
 * C'est NOTRE lecture du score, pas une mesure du serveur : aucun palier n'est renvoyé par lui.
 */
export function palierScore(score: number): PalierScore {
  // NaN passe tous les `<` ci-dessous et tomberait sur « excellent » : un score absent est le plus bas.
  if (!Number.isFinite(score)) return 'faible';
  const s = Math.max(0, Math.min(100, Math.round(score)));
  if (s < 60) return 'faible';
  if (s < 75) return 'correct';
  if (s <= 85) return 'bon';
  return 'excellent';
}
